import React from 'react';
import { flattenToAppURL, hasBlocksData } from '@plone/volto/helpers';
import RenderBlocks from '@plone/volto/components/theme/View/RenderBlocks';
import { Grid, Image, Ref, Sticky } from 'semantic-ui-react';
import { FormattedDate, Icon } from '@plone/volto/components';
import dateSVG from '../../../icons/date.svg';
import locationSVG from '../../../icons/location.svg';
import viewsSVG from '../../../icons/views.svg';

const NewsItemView = ({ content }) => {
  const contextRef = React.createRef();

  const visitorIds = content?.visited_user_ids ?? [];
  const creatorDetails = content?.creators_details
    ? content.creators_details[0]
    : {};

  //noinspection JSUnresolvedVariable
  return (
    <>
      {hasBlocksData(content) ? (
        <>
          <div id="page-document" className="ui container">
            <Ref innerRef={contextRef}>
              <Grid columns={3}>
                <Grid.Column
                  className={'left-column'}
                  computer={2}
                  mobile={12}
                ></Grid.Column>
                <Grid.Column
                  className={'newsitem-content'}
                  computer={8}
                  mobile={12}
                >
                  <div id="blocks-content">
                    {content.headline ? (
                      <span className="headline">Schlagzeile</span>
                    ) : (
                      <></>
                    )}
                    <RenderBlocks content={content} />
                  </div>
                </Grid.Column>
                <Grid.Column
                  className={'newsitem-author'}
                  computer={2}
                  mobile={12}
                >
                  <Sticky context={contextRef} offset={25}>
                    <div className="author-details">
                      {creatorDetails && (
                        <div className="author-detail username">
                          <div className="icon-wrapper">
                            <Image
                              src={flattenToAppURL(
                                '/@portrait/' + creatorDetails.id,
                              )}
                              alt={creatorDetails.id}
                              title={creatorDetails.fullname}
                            />
                          </div>
                          <div className="value-wrapper">
                            {creatorDetails.fullname}
                          </div>
                        </div>
                      )}
                      <div className="author-detail created">
                        <div className="icon-wrapper">
                          {
                            <Icon
                              className={'date-icon'}
                              name={dateSVG}
                              size={'20px'}
                            />
                          }
                        </div>
                        {<FormattedDate date={content.created} />}
                      </div>
                      <div className="author-detail visited">
                        <div className="icon-wrapper">
                          {
                            <Icon
                              className={'views-icon'}
                              name={viewsSVG}
                              size={'20px'}
                            />
                          }
                        </div>
                        <div className="value-wrapper">{visitorIds.length}</div>
                      </div>
                      <div className="author-detail location">
                        <div className="icon-wrapper">
                          {
                            <Icon
                              className={'location-icon'}
                              name={locationSVG}
                              size={'20px'}
                            />
                          }
                        </div>
                        <div className="value-wrapper">
                          {content.location.map(function (location, i) {
                            return (
                              <div key={i} className={location.token}>
                                {location.title}
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    </div>
                  </Sticky>
                </Grid.Column>
              </Grid>
            </Ref>
          </div>
        </>
      ) : (
        <></>
      )}
    </>
  );
};

export default NewsItemView;
